import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import I18NextHttpBackend from 'i18next-http-backend';
import { LANGUAGE_CODES } from './common/constants/languageCodes';
import { IMPERSONATION_NAMESPACE } from './common/constants/impersonation';
import { isImpersonationTab } from './services/impersonationSession';

// An impersonation tab keeps the admin's language choice to itself instead of overwriting the browser-wide one, and
// loads its namespace up front: its toasts are raised from the axios interceptor, outside any component.
const isImpersonating = isImpersonationTab();

i18next
    .use(initReactI18next)
    .use(I18nextBrowserLanguageDetector)
    .use(I18NextHttpBackend)
    .init({
        fallbackLng: LANGUAGE_CODES.ENGLISH,
        load: 'languageOnly',
        supportedLngs: Object.values(LANGUAGE_CODES),
        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: `/locales/{{lng}}/{{ns}}.json?v=${Date.now()}`,
        },
        detection: isImpersonating
            ? {
                  order: ['querystring', 'cookie', 'sessionStorage', 'localStorage', 'navigator', 'htmlTag'],
                  caches: ['sessionStorage'],
              }
            : undefined,
        react: {
            useSuspense: true,
        },
        defaultNS: 'common',
    });

if (isImpersonating) {
    i18next.loadNamespaces(IMPERSONATION_NAMESPACE);
}
